import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { palette } from "./palette";
import { merge } from "lodash";
import { CssBaseline, ThemeProvider, createTheme, } from "@mui/material";
import { componentsOverrides } from "./overrides";
import { customShadows } from "./custom-shadows";
import { shadows } from "./shadows";
import { typography } from "./typography";
export default function CustomThemeProvider({ children }) {
    const baseOption = useMemo(() => ({
        palette: palette("light"),
        shadows: shadows("light"),
        customShadows: customShadows("light"),
        typography,
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 900,
                lg: 1200,
                xl: 1536,
            },
        },
        shape: { borderRadius: 8 },
    }), []);
    const memoizedValue = useMemo(() => merge(
    // Base
    baseOption), [baseOption]);
    const theme = createTheme(memoizedValue);
    theme.components = merge(componentsOverrides(theme));
    return (_jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), children] }));
}
